<script>
export default {
  name: 'WorkerListMixin',
  data: () => ({

  }),
  computed: {
    getHeaderList () {
      return [
        {
          text: 'Работник',
          align: 'left',
          sortable: true,
          value: 'laborer.supportNumber',
        },
        {
          text: 'Заявка',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Отклик',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Приглашение',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Смена',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Объект',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Вакансия',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        { text: 'Создан', value: 'dateString', sortable: false },
        {
          text: 'Начало',
          align: 'left',
          sortable: true,
          value: 'startAtString',
        },
        { text: 'Конец', value: 'endAtString', sortable: true },
        { text: 'Просмотры', value: 'views', sortable: true },
        {
          text: 'Видимость',
          align: 'left',
          sortable: false,
          value: 'accessLevel',
        },
        { text: 'наз. исполнителя', value: 'executorAssignmentType.label', sortable: false },
        { text: 'рабочие места', value: 'workPlaces', sortable: true },
        { text: 'Отклики', value: 'respondCounter', sortable: true },
        { text: 'приглашения', value: 'invitationCounter', sortable: true },
        { text: 'Смены', value: 'shiftCounter', sortable: true },
        {
          text: 'Статус',
          align: 'left',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Исполнитель',
          align: 'left',
          sortable: false,
          value: 'executor',
        },
        {
          text: 'Вакансия',
          align: 'left',
          sortable: false,
          value: 'vacancy',
        },
        {
          text: 'Объект',
          align: 'left',
          sortable: false,
          value: 'office',
        },
        {
          text: 'Организация',
          align: 'left',
          sortable: false,
          value: 'organization',
        },
        {
          text: 'Населенный пункт',
          align: 'left',
          sortable: false,
          value: 'locality.title',
        },
        { text: 'Длительность', value: 'duration', sortable: false },
        { text: 'Перерыв', value: 'break.duration', sortable: false },
        { text: 'Создатель', value: 'author', sortable: false },
        { text: 'Ставка', value: 'costPerHour', sortable: false },
        { text: 'ФОТ', value: 'expense', sortable: false },
        { text: 'ЗП', value: 'pay', sortable: false },
      ]
    }
  },
  methods: {

  }
}
</script>
